import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";

const UserInfo = ({ 
 data,
  handleChangeInput,
  handleChangeDropdown,
  viewMode,
  deleted,
  addNewItem,
  isExists,
  handleParentDropdownChange,
  typeDuplicate
}) => {

  return (
    <div className="Tenant-info">
      <div className="Tenant-info_column">
        {isExists && (
          <p className="errorText">
            {typeDuplicate
              ? typeDuplicate
              : " Given User Details Already Exists"}
          </p>
        )}
        <Input
          className="Tenant-info_column_item"
          valueType="text"
          name="username"
          label="User Name*"
          value={`${(data && data.first_name) ? data.first_name : ''} ${(data && data.last_name) ? data.last_name : ''}`.trim()}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
          disabled
        />
        {/* <Input
          className="Tenant-info_column_item"
          required
          valueType="email"
          name="email"
          label="Email*"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
         
          {/* <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionKey='code'
            optionLabelKey='name'
            optionsType="type_code"
            value={data.type_code}
            valueKey="type_code"
            label="User Type"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
            required
        />    */}  
        <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionKey='code'
            optionLabelKey='name'
            optionsType="user_type"
            value={data.user_type}
            valueKey="user_type"
            label="User Rights"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
        />    
          <Dropdown
            className="Team-member-info_column_item"
            data={data}
            optionKey='code'
            optionLabelKey='name'
            optionsType="status_code"
            value={Array.isArray(data.status_code) ? data.status_code.join(",") : data.status_code || ""}
            valueKey="status_code"
            label="Status"
            handleParentChange={handleChangeDropdown}
            viewMode={viewMode}
            deleted={deleted}
        />    
        {/* <Input
          className="Tenant-info_column_item"
          required
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          required
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
        {/* <Input
          className="Tenant-info_column_item"
          //name="COMPANY_ADDRESS"
          name="address"
          label="Address"
          //value={data.COMPANY_ADDRESS}
          value={data.address}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          valueType="text"
          //name="CITY"
          name="city"
          label="CITY"
          //value={data.CITY}
          value={data.city}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />

        <Dropdown
          className="Tenant-info_column_item"
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          // value={data.STATE}
          // valueKey="STATE"
          value={data.state}
          valueKey="state"
          label="STATE"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          //name="COMPANY_ZIP"
          name="zip"
          label="Zip"
          value={getCompanyZIP()}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
        {/* <Dropdown
          className="Tenant-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Contact Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
          viewMode={viewMode}
        /> */}
      </div>

      <div className="Tenant-info_column">
        <div>
           {/* <Input
          className="Tenant-info_column_item"
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Tenant-info_column_item"
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
          {/* <Input
            className="Tenant-info_column_item"
            required
            valueType="phone"
            name="cell_phone"
            label="Cell Phone"
            value={data.cell_phone}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          /> */}
            {/* <Dropdown
          className="Tenant-info_column_item"
          data={data ? data : []}
          optionsType="role"
          optionKey="role"
          optionLabelKey="name"
          // value={data.STATE}
          // valueKey="STATE"
          value={data.role ? data.role : []}
          valueKey="role"
          label="Role"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
        { !data.contact_id &&  <Input
            className="Tenant-info_column_item"
            required
            valueType="text"
            name="password"
            label="Password*"
            value={data.password}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />}
          
          {/* <Input
          className="Tenant-info_column_item"
          required
          valueType="phone"
          name="cell_phone"
          label="Cell Phone"
          value={data.cell_phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        
        <Input
          className="Tenant-info_column_item"
          required
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
           <Input
          className="Tenant-info_column_item"
          required
          valueType="password"
          name="password"
          label="Password"
        value={data.passworduserList}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        /> */}
          {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
          {/* {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Lender")  )  : data.contact_type.split(",").includes("Lender")) ?

          <Input
            className="Tenant-info_column_item"
            name="name"
            required
            label="Lender Name"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        } */}
          {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
          {/* {data.contact_type && (Array.isArray(data.contact_type) ? data.contact_type.some((type) => type.split(",").includes("Lender")  )  : data.contact_type.split(",").includes("Lender")) ?

          <Textarea
            className="Tenant-info_column_item"
            required
            valueType="text"
            inputType="textarea"
            //name="notes"
            name="notes"
            label="Notes"
            //value={data.NOTES}
            value={data.notes}
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
            maxWidth="100%"
          /> : ""
        } */}
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
